import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-danger small table-border mb-1"
}
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted, watch } from 'vue';

// --- Component Properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'MermaidDiagram',
  props: {
    source: {},
    diagramId: {}
  },
  emits: ["rendered"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Emits ---
const emits = __emit;

const svg = ref('');
const error = ref<string | null>(null);
let seq = 0;

async function render() {
  const source = props.source?.trim();
  if (!source) {
    svg.value = '';
    error.value = null;
    return;
  }
  try {
    // dynamic import keeps mermaid out of the main bundle
    const { default: mermaid } = await import('mermaid');
    mermaid.initialize({ startOnLoad: false, securityLevel: 'strict' });
    // mermaid renders into a detached node, so a collapsed parent is fine
    const { svg: rendered } = await mermaid.render(
      `mmd-${props.diagramId ?? 'x'}-${seq++}`,
      source
    );
    svg.value = rendered;
    error.value = null;
    emits('rendered');
  } catch (e) {
    console.error('Failed to render mermaid diagram', e);
    error.value = e instanceof Error ? e.message : String(e);
    svg.value = '';
  }
}

onMounted(render);
watch(() => props.source, render);

return (_ctx: any,_cache: any) => {
  return (error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Failed to render diagram: " + _toDisplayString(error.value), 1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "mermaid-diagram mb-1",
        innerHTML: svg.value
      }, null, 8, _hoisted_2))
}
}

})